import React from 'react';
import 'chart.js/auto';
import { Radar } from 'react-chartjs-2'
import { Chart, Title } from "chart.js";

const RadarChart = (props) => {
    Chart.register(Title);

    return (
        <div>
            <Radar key={props.key} data={props.chartData}
                height={props.height}
                width={props.width}
                options={props.options}
            />
        </div>
    );
};

export default RadarChart;
